import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SimulationInput } from '@app/shared';
import { createSimulation, fetchAssumptions, fetchSimulation, fetchSimulations } from './api';

const simulationsKey = ['simulations'] as const;
const simulationKey = (id: number) => [...simulationsKey, id] as const;
const assumptionsKey = ['assumptions'] as const;

export const assumptionsQueryOptions = queryOptions({ queryKey: assumptionsKey, queryFn: fetchAssumptions });
export const simulationsQueryOptions = queryOptions({ queryKey: simulationsKey, queryFn: fetchSimulations });
export const simulationQueryOptions = (id: number) =>
  queryOptions({ queryKey: simulationKey(id), queryFn: () => fetchSimulation(id) });

export function useAssumptions() {
  return useQuery(assumptionsQueryOptions);
}

export function useSimulations() {
  return useQuery(simulationsQueryOptions);
}

export function useSimulation(id: number) {
  return useQuery(simulationQueryOptions(id));
}

export function useCreateSimulation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: SimulationInput) => createSimulation(input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: simulationsKey }),
  });
}
